<template>
    <div v-bind="field?.controlAttrs.value" role="group" :aria-labelledby="field?.labelId" class="checkbox-group">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { computed, provide } from "vue";

import { checkboxGroupContextKey } from "./checkboxGroupContext";
import { useFormField } from "./formFieldContext";

// Several BaseCheckboxes under one FormField: the group takes the field's id, describedby and
// invalid wiring and is named by the field's label (a `for` cannot reach a group), while each
// checkbox keeps its own id and is named by its own inline label. Used bare, name the group with
// an aria-label or aria-labelledby attribute; attrs passed here override the field bindings.
const field = useFormField();

provide(checkboxGroupContextKey, {
    invalid: computed(() => field?.invalid.value ?? false),
    describedBy: computed(() => (field?.invalid.value ? field.describedBy.value : undefined)),
});
</script>

<style scoped>
@reference "../../../../css/tailwind.css";

@layer components {
    .checkbox-group {
        @apply flex flex-col gap-3;
    }
}
</style>
